import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import { Row } from "react-bootstrap";

import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import GenDocBenefits from "./GenDocBenefits";
import GenDocFeatures from "./GenDocFeatures";
// Main component for GenDoc Stack
export default function GenDocStack() {

  // Data for the first section (features related to the GenDoc Stack)
  const data1 = [
    "Content Server: The content server facilitates the management of content within the category, allowing users to upload various media types like images and videos. It includes features such as setting expiry dates for content, detailed descriptions, and attribution to content creators, ensuring organized and relevant information for users in the purchasing sector.",
    "DocGen & Management: DocGen Management empowers users to effortlessly generate documents, streamlining the process with its user-friendly interface and efficient functionality. Seamlessly create a variety of documents tailored to your needs with ease and convenience.",
    "IAM: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
  ];

  // Data for the second section (supporting data storage and security)
  const data2 = [
    "S3: S3 is used for scalable, durable, and reliable cloud storage, allowing users to securely store and retrieve data of any size from anywhere on the web.",
    "DB: The database (DB) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation.",
  ];

  return (
    <>
      {/* Banner Section */}
      <UpdatesBanner
        className="sdh-bg"
        bannerTitle="DocGen Stack"
        bannerbodycopy="Asset Behaviour | Site Behaviour | Actors Behaviour"
      />

      {/* Overview Section */}
      <SolutionEcosystem title="Overview" type="DocGen" />

      {/* Features Section */}
      <Container>
        <Row>
          <OverviewFeatures data1={data1} data2={data2} />
        </Row>
      </Container>

      {/* GenDoc Features Section */}
      <GenDocFeatures />

      {/* GenDoc Benefits Section */}
      <GenDocBenefits />

      {/* Call-to-Action Section */}
      <Container className="subSectionWrapper">
        <CTA
          btnText="View APIs"
          href4="/ComingSoon"
          heading="Do you want to develop applications or integrate your legacy hardware and software..."
        />
      </Container>
    </>
  );
}

